import React, { useContext } from "react";


import { observer } from "mobx-react-lite";
import { toJS } from "mobx";
import { playerStoreContext } from "lib/player_store";

const PlayerMainRow = observer(({ children }) => {
  const store = useContext(playerStoreContext);

  const {
 //   songInfo: { song },
    albumArtPalette: { light, dark },
  } = store;

  /* can't css transition background linear-gradient, 
        framer-motion and others are large libraries just for this, 
        try transition opacity */

 const nowPlayingBG = {
      "--light-main-row": `rgba(${toJS(light).toString()}, 0.7)`, 
      "--dark-main-row": `rgba(${toJS(dark).toString()}, 0.7)`,
  };

  // if (window.Proxy) {
  //   return (
  //     <Suspense fallback={null}>
  //       <MotionDiv2 mainPlayerCSS={mainPlayerCSS}>{children}</MotionDiv2>
  //     </Suspense>
  //   );
  // }

  return (
    <div id="player_main_row" style={nowPlayingBG}>
      {children}
    </div>
  );
});

export default PlayerMainRow;
